import {
  propOr,
  curry,
  pick,
  compose,
  match,
  map,
  join,
  toLower,
  toString,
} from 'ramda'

export const ssrWarning =
  '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */'
export const maybePropFrom = curry((obj, prop) => propOr('', prop)(obj))
export const pickToCss = curry((props, obj) =>
  compose(toCss, kebabalizeKeys, pick(props))(obj)
)

const kebabalize = compose(
  join('-'),
  map(toLower),
  match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g),
  toString
)

const kebabalizeKeys = (obj) =>
  Object.keys(obj).reduce(
    (acc, current) => ({
      ...acc,
      [kebabalize(current)]: obj[current],
    }),
    {}
  )

const toCss = (obj) =>
  Object.keys(obj).reduce(
    (acc, current) => `
      ${acc}
      ${current}: ${obj[current]};
    `,
    ''
  )
